import React, { useCallback, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { endpointInstance } from "../methods/Methods";
import _ from "lodash";
import { Button, Col, Divider, Row, Typography } from "antd";
import { StyleSheet } from "../StyleSheet";
import HeaderComponent from "../components/HeaderComponent";
import stylesCss from "./payments.module.css";
import { PayPalButtons, PayPalScriptProvider } from "@paypal/react-paypal-js";
import Loading from "../components/Loading";
import PaymentForms from "../components/PaymentForms";
import AlertModal, { PaymentData } from "../components/AlertModal";
import InfoCardComponent from "../components/InfoCardComponent";
import { LeftOutlined } from '@ant-design/icons';


const { Text } = Typography;

const Payments = () => {
    const navigate = useNavigate();
    const CryptoJS = require("crypto-js");
    const [idCliente, setIdCliente] = React.useState<string>("");
    const [clientId, setClientID] = React.useState<string>("");
    const [name, setName] = React.useState<string>("");
    const [concept, setConcept] = React.useState<string>("");
    const [balance, setBalance] = React.useState<string>("");
    const [textModal, setTextModal] = React.useState("");
    const [errorMessage, setErrorMessage] = React.useState("");
    const [showModal, setShowModal] = React.useState(false);
    const [loading, setLoading] = React.useState<boolean>(true);
    const [hasError, setHasError] = React.useState<boolean>(false);
    const [hasRecentPayment, setHasRecentPayment] = React.useState<boolean>(false);
    const [isReceiptPayment, setIsReceiptPayment] = React.useState<boolean>(false);
    const [paymentData, setPaymentData] = React.useState<PaymentData>();
    const call = endpointInstance;

    const getBalance = useCallback(async () => {
        await call
            .getBalance(idCliente)
            .then((response) => {
                if (response.data.data[0].datos.amount) {
                    setBalance(response.data.data[0].datos.amount);
                    localStorage.setItem("balance", response.data.data[0].datos.amount);
                } else {
                    setErrorMessage("Por el momento no es posible mostrar información de su contrato, intente más tarde.");
                    setHasError(true);
                }
                if (response.data.data[0].datos.paymentLimitDate) {
                    localStorage.setItem(
                        "limit",
                        response.data.data[0].datos.paymentLimitDate
                    );
                }
            })
            .catch(() => {
                setErrorMessage("Por el momento no es posible mostrar información de su contrato, intente más tarde.");
                setHasError(true);
            });
    }, [call, idCliente]);

    const getName = useCallback(async () => {
        const body = {
            sucursal: idCliente.substring(0, 3),
            suscriptor: idCliente.substring(3, 10),
        };
        await call
            .getSuscriptorName(body)
            .then((response) => {
                if (response.data.data[0].nombre && response.data.data[0].paquete) {
                    setName(response.data.data[0].nombre);
                    setConcept(response.data.data[0].paquete);
                    localStorage.setItem("name", response.data.data[0].nombre);
                    localStorage.setItem("concept", response.data.data[0].paquete);
                } else {
                    setErrorMessage("Por el momento no es posible mostrar información de su contrato, intente más tarde.");
                    setHasError(true);
                }
            })
            .catch(() => {
                setErrorMessage("Por el momento no es posible mostrar información de su contrato, intente más tarde.");
                setHasError(true);
            });
    }, [call, idCliente]);

    const getHasPayment = useCallback(async () => {
        await call
            .getRecentPayment(idCliente)
            .then((response) => {
                if (response.data.data[0].status) {
                    if (response.data.data[0].hasPayment) {
                        setErrorMessage(response.data.data[0].message);
                        setHasRecentPayment(true);
                    }
                } else {
                    setErrorMessage("Por el momento no es posible mostrar información de su contrato, intente más tarde.");
                    setHasRecentPayment(true);
                }
            })
            .catch(() => {
                setErrorMessage("Por el momento no es posible mostrar información de su contrato, intente más tarde.");
                setHasRecentPayment(true);
            })
    }, [call, idCliente]);

    const initialOptions = {
        "client-id": clientId,
        currency: "MXN",
        components: "buttons",
    };

    function _arrayBufferToBase64(buffer: any) {
        var binary = "";
        var bytes = new Uint8Array(buffer);
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    }

    function base64toHEX(base64: any) {
        var raw = atob(base64);
        var HEX = "";
        for (let i = 0; i < raw.length; i++) {
            var _hex = raw.charCodeAt(i).toString(16);
            HEX += _hex.length === 2 ? _hex : "0" + _hex;
        }
        return HEX.toUpperCase();
    }

    function cifrarAES(data: any, password: any) {
        let buf = new Uint8Array(16);
        window.crypto.getRandomValues(buf); //Obtenermos 16 bytes
        let buffer_b64 = _arrayBufferToBase64(buf); //
        let iv = CryptoJS.enc.Hex.parse(base64toHEX(buffer_b64));
        var key = CryptoJS.enc.Hex.parse(password);

        let cipherParams = {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        };

        let encrypted = CryptoJS.AES.encrypt(
            JSON.stringify(data),
            key,
            cipherParams
        );

        let merge = encrypted.iv.clone();
        merge.concat(encrypted.ciphertext);
        let merge2 = CryptoJS.enc.Base64.stringify(merge);

        return merge2;
    }

    const createOrder = async () => {
        let sucursal = idCliente.substring(0, 3);
        let suscriptor = idCliente.substring(3, 10);

        let objData = {
            sucursal: sucursal,
            suscriptor: suscriptor,
            monto: balance.replace(/,/g, ""),
            origen: "NPP",
            returnUrl: "https://example.com/return",
            cancelarUrl: "https://example.com/return",
            metadata: "",
        };

        let dataEncrypted = cifrarAES(objData, "5DCC67393750523CD165F17E1EFADD21");

        let objDataEncrypted = {
            param: dataEncrypted,
        };

        let orderTmp = "";

        await call
            .paypalGenerateOrder(objDataEncrypted)
            .then((response) => {
                if (response.data.data[0].estatus === "1") {
                    orderTmp = response.data.data[0].id_operacion;
                } else if (response.data.data[0].estatus === "4") {
                    setTextModal(response.data.data[0].mensaje);
                    setShowModal(true);
                } else {
                    setTextModal(
                        "Su pago no ha sido procesado con PayPal, intente más tarde."
                    );
                    setShowModal(true);
                }
            })
            .catch((error) => {
                setTextModal(
                    "Su pago no ha sido procesado con PayPal, intente más tarde."
                );
                setShowModal(true);
            });

        return orderTmp;
    };

    const onApprove = async (data: any) => {
        let sucursal = idCliente.substring(0, 3);
        let suscriptor = idCliente.substring(3, 10);
        let objData = {
            sucursal: sucursal,
            suscriptor: suscriptor,
            id_operacion: data.orderID,
            origen: "NPP",
            metadata: "",
        };

        await call
            .paypalOrderStatus(objData)
            .then((response) => {
                if (response.data.data[0].estatus === "1") {
                    const fecha = new Date(response.data.data[0].fecha);
                    const dateFormatted = fecha.toLocaleDateString('es-MX', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric'
                    });
                    const hourFormatted = fecha.toLocaleTimeString('es-MX', {
                        hour: '2-digit',
                        minute: '2-digit',
                        second: '2-digit'
                    });
                    setPaymentData({
                        date: dateFormatted,
                        time: hourFormatted,
                        amount: balance,
                        name: name,
                        client: idCliente,
                        idTransaction: response.data.data[0].id_transaccion,
                        concept: concept,
                        card: ""
                    });
                    setIsReceiptPayment(true);
                    setShowModal(true);
                } else {
                    setTextModal("Su pago no ha sido procesado con PayPal, intente más tarde.");
                    setShowModal(true);
                }
            })
            .catch(() => {
                setTextModal("No fue posible pagar con PayPal, intenta más tarde.");
                setShowModal(true);
            });
    };

    const onCancel = async (data: any) => {
        let objData = {
            id_operacion: data.orderID,
            cancelar_url: "https://example.com/return",
        };

        await call
            .paypalOrderCancel(objData)
            .then((response) => {
                setTextModal(response.data.data[0].mensaje);
                setShowModal(true);
            })
            .catch(() => { });
    };

    const redirectToPayment = () => {
        navigate("/pay-with-card");
    };

    useEffect(() => {
        const idClienteTmp = localStorage.getItem("idCliente");
        if (idClienteTmp && !_.isEmpty(idClienteTmp)) {
            setIdCliente(idClienteTmp);
        }

        const clientTmp = localStorage.getItem("clientId");
        if (clientTmp && !_.isEmpty(clientTmp)) {
            setClientID(clientTmp);
        }
    }, []);

    useEffect(() => {
        if (balance !== "" && name !== "") {
            setLoading(false);
        } else if (hasError) {
            setLoading(false);
        }
    }, [balance, name, hasError]);

    useEffect(() => {
        if (idCliente && !_.isEmpty(idCliente)) {
            getName();
            getBalance();
            getHasPayment();
        }
    }, [idCliente, getBalance, getName, getHasPayment]);

    return (
        <>
            {
                loading ?
                    <Loading />
                    :
                    hasError ?
                        <>
                            <HeaderComponent />
                            <div style={styles.pageContainer}>
                                <Row style={styles.formContainer} justify={'center'}>
                                    <Col span={16}>
                                        <InfoCardComponent
                                            color="#FFC439" colorText="#000"
                                            description={errorMessage} />
                                    </Col>
                                    <Col span={16} style={styles.rowErrorButton}>
                                        <Button
                                            size='large'
                                            type="primary"
                                            style={styles.buttonReturn}
                                            onClick={() => navigate("/")}
                                        >
                                            <LeftOutlined />
                                            Regresar
                                        </Button>
                                    </Col>
                                </Row>
                            </div>
                            <PaymentForms />
                        </>
                        :
                        <>
                            <HeaderComponent />
                            <Row justify={'center'} style={styles.principal}>
                                <Row style={styles.rowTitle}>
                                    <Text style={styles.textTitle} className="page-title">
                                        Paga en Línea tus servicios de Mega
                                    </Text>
                                </Row>
                                <Row style={styles.rowDivider}>
                                    <Col span={2}>
                                        <Divider style={styles.divider} />
                                    </Col>
                                </Row>
                                <Row style={styles.rowText} className={stylesCss.textPayments} justify={'center'}>
                                    <div style={{ display: 'flex', justifyContent: 'center' }} className={stylesCss.textPaymentsTwo}>
                                        <Text style={styles.text} className="page-text">
                                            A continuación se muestran las iniciales del nombre que está
                                            dado de alta su servicio Mega, si no coinciden,
                                            de click en "No son mis iniciales"
                                        </Text>
                                    </div>
                                </Row>
                                <Row style={styles.rowText} className={stylesCss.textPayments} justify={'center'}>
                                    <Text style={styles.textNameUser}>
                                        {name}
                                    </Text>
                                </Row>
                                <Row style={styles.rowText} className={stylesCss.textPayments} justify={'center'}>
                                    <Link
                                        style={{ color: "#1786ff", textDecoration: 'underline', textDecorationColor: '#1786ff' }}
                                        to={"https://pagoenlinea.megacable.com.mx/"}
                                        target='_blank'
                                    >
                                        No son mis iniciales
                                    </Link>
                                </Row>
                                <Row style={styles.rowDivider}>
                                    <Col span={2}>
                                        <Divider style={styles.divider} />
                                    </Col>
                                </Row>
                                <Row style={{ ...styles.principal, marginBottom: hasRecentPayment ? 0 : 50 }} className={stylesCss.textPayments} justify={'center'}>
                                    <Text style={styles.ligthText}>
                                        ¡AHORA DE FORMA MÁS DIRECTA PAGA TU SERVICIO MEGA!
                                    </Text>
                                </Row>
                                {
                                    hasRecentPayment &&
                                    (
                                        <Row style={{ ...styles.principal, marginBottom: 0 }} className={stylesCss.textPayments} justify={'center'}>
                                            <Col span={16}>
                                                <InfoCardComponent
                                                    color="#FFC439"
                                                    colorText="#000"
                                                    description={errorMessage}
                                                />
                                            </Col>
                                        </Row>
                                    )
                                }
                                <Row style={styles.rowBalance} className={stylesCss.textPayments} justify={'center'}>
                                    <Text style={styles.textBalance}>
                                        Saldo al corte: ${balance}
                                    </Text>
                                </Row>
                                {
                                    hasRecentPayment ?
                                        <Row style={styles.rowBalance} className={stylesCss.textPayments} justify={'center'}>
                                            <Button
                                                size='large'
                                                type="primary"
                                                style={styles.buttonReturn}
                                                onClick={() => navigate("/")}
                                            >
                                                <LeftOutlined />
                                                Regresar
                                            </Button>
                                        </Row>
                                        :
                                        <>
                                            {
                                                balance && Number(balance.replace(/[,]/g, "")) >= 11 ?
                                                    <Row style={styles.principal} className={stylesCss.textPayments} justify={'center'}>
                                                        <Text style={styles.ligthText}>
                                                            ELIGE TU FORMA DE PAGO
                                                        </Text>
                                                    </Row>
                                                    :
                                                    null
                                            }
                                            <Row style={styles.rowDivider}>
                                                <Col span={2}>
                                                    <Divider style={styles.divider} />
                                                </Col>
                                            </Row>
                                            <Row className={stylesCss.rowButtons} justify={'center'}>
                                                {
                                                    clientId && !_.isEmpty(clientId) && balance && Number(balance.replace(/[,]/g, "")) >= 11 ?
                                                        <div className={stylesCss.paypalContainer}>
                                                            <PayPalScriptProvider options={initialOptions}>
                                                                <PayPalButtons
                                                                    style={{
                                                                        color: "blue",
                                                                        shape: "pill",
                                                                        label: "pay",
                                                                        tagline: false,
                                                                        layout: "horizontal",
                                                                        height: 40
                                                                    }}
                                                                    createOrder={createOrder}
                                                                    onApprove={onApprove}
                                                                    onCancel={onCancel}
                                                                />
                                                            </PayPalScriptProvider>
                                                        </div>
                                                        :
                                                        null
                                                }
                                                {
                                                    balance && Number(balance.replace(/[,]/g, "")) >= 11 ?
                                                        <div className={stylesCss.paypalContainer}>
                                                            <Button
                                                                size='large'
                                                                style={{ ...styles.buttonPrimary, backgroundColor: '#0055c2' }}
                                                                onClick={() => redirectToPayment()}
                                                            >
                                                                Pagar con tarjeta
                                                            </Button>
                                                        </div>
                                                        :
                                                        null
                                                }
                                            </Row>
                                            <Row style={styles.rowButtons} className={stylesCss.textPayments} justify={'center'}>
                                                <Row style={styles.rowButtons} className={stylesCss.textPayments} justify={'center'}>
                                                    <Button
                                                        size='large'
                                                        type="primary"
                                                        ghost
                                                        style={styles.buttonReturn}
                                                        onMouseEnter={(e: any) => {
                                                            e.currentTarget.style.backgroundColor = "#0079FF";
                                                            e.currentTarget.style.color = "#ffffff";
                                                            e.currentTarget.style.borderColor = "#0079FF";
                                                        }}
                                                        onMouseLeave={(e: any) => {
                                                            e.currentTarget.style.backgroundColor = "transparent";
                                                            e.currentTarget.style.color = "#0079FF";
                                                            e.currentTarget.style.borderColor = "#0079FF";
                                                        }}
                                                        onClick={() => navigate("/")}
                                                    >
                                                        Cancelar
                                                    </Button>
                                                </Row>
                                            </Row>
                                        </>
                                }
                            </Row>
                            <PaymentForms />
                        </>
            }
            <AlertModal
                show={showModal}
                title={"Pago PayPal"}
                message={textModal}
                isReceiptPayment={isReceiptPayment}
                paymentData={paymentData}
            />
        </>
    );
};

const styles = StyleSheet.create({
    pageContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '90vh',
    },
    principal: {
        padding: 15,
        marginBottom: 50,
        display: 'flex',
        flexDirection: 'row'
    },
    rowTitle: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%'
    },
    rowErrorButton: {
        marginTop: 25,
        display: 'flex',
        justifyContent: 'center'
    },
    rowDivider: {
        marginTop: 25,
        display: 'flex',
        justifyContent: 'center'
    },
    rowText: {
        marginTop: 15,
        display: 'flex',
        justifyContent: 'center'
    },
    ligthText: {
        fontSize: 16,
        textAlign: 'center'
    },
    divider: {
        borderBlockStart: "1px solid #c8c8c8",
        margin: "20px 0px 10px",
        color: "#c8c8c8"
    },
    rowBalance: {
        padding: 15,
        display: 'flex',
        justifyContent: 'center'
    },
    textTitle: {
        color: 'black',
        fontWeight: 700,
        textAlign: 'center',
        lineHeight: 1.2
    },
    text: {
        color: '#212529',
        fontWeight: 400,
        textAlign: 'center',
        marginTop: 5
    },
    textNameUser: {
        color: '#182b74',
        fontSize: 30,
        fontWeight: 700,
        textAlign: 'center'
    },
    textBalance: {
        fontSize: 25,
        color: 'black',
        fontWeight: 800,
        textAlign: 'center',
    },
    rowButtons: {
        marginTop: 20,
        display: 'flex',
        justifyContent: 'center'
    },
    buttonPrimary: {
        padding: "0px 25px 0px 25px",
        borderRadius: 20,
        color: 'white',
        fontSize: 13,
        width: 300,
        textTransform: "uppercase",
    },
    buttonReturn: {
        backgroundColor: 'transparent',
        borderRadius: 20,
        color: '#0079FF',
        borderColor: '#0079FF',
        fontSize: 13,
        width: 300,
        textTransform: "uppercase",
        boxShadow: "3px 3px 5px 0px rgba(0,0,0,0.10)",
    },
    errorMessage: {
        fontSize: 14,
        margin: 0
    },
    formContainer: {
        marginTop: "2rem",
    },
});

export default Payments;
